import { LandingPageComponent } from "./landing-page/landing-page.component";

export const containers: any[] = [
    LandingPageComponent
];

export * from './landing-page/landing-page.component';